<template>
    <BuilderBase :loading="datasetStore.loading">
        <template v-slot:section-title>
            <div class="content">
                <h1 class="h1">
                    <span class="steps">{{$t('common.step_1')}} 2<span class="slash">/</span>3:</span> <span class="title" v-html="$t('views.dataset_specification.title_short', { count: formatNumber(datasetStore.count) })"></span>
                </h1>
            </div>
        </template>

        <template v-slot:section-content>
            <SpecificationOptions />
        </template>
    </BuilderBase>
</template>

<script>
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import BuilderBase from '@/views/builder/BuilderBase';
    import SpecificationOptions from '@/components/builder/specification/SpecificationOptions';
    import { formatNumber } from '@/utils/formatting';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            BuilderBase,
            SpecificationOptions
        },
        data() {
            return {
                seo_title: 'views.dataset_specification.seo_title'
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            formatNumber
        },
        async mounted() {
            if(!this.datasetStore.facets) {
                const success = await this.datasetStore.fetchDataset(true);
                if(!success || !this.datasetStore.count || !this.datasetStore.price || !this.datasetStore.query) {
                    this.$router.push({name: 'builder'});
                }
            }
        }
    }
</script>